import { render } from "./chevron-down.vue?vue&type=template&id=487895f0"
import script from "./chevron-down.vue?vue&type=script&setup=true&lang=js"
export * from "./chevron-down.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.5.17_webpack@5.97.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"packages/ui-components/src/components/icons/chevron-down/chevron-down.vue"]])

export default __exports__